import { createSelector } from '@reduxjs/toolkit';
import { useGetApprovalItemsQuery } from 'features/comments/approvalApi';

const findApprovalItem = createSelector(
    (res) => (res.currentData ? res.currentData['hydra:member'] : undefined),
    (_data, blockId) => blockId,
    /**
     * @param {import('models/approval.models').ApprovalItem[]} data
     * @param {number} blockId
     */
    (data, blockId) => {
        if (!data) {
            return undefined;
        }
        const approvalItems = data.filter((item) => item.target.externalId === `${blockId}`);

        return approvalItems.length > 0 ? approvalItems[0] : undefined;
    },
);

/**
 * @param {number} blockId
 * @param {number} areaId
 *
 * @return {import('models/approval.models').ApprovalItem | undefined}
 */
export function useGetBlockApprovalItem(blockId, areaId) {
    const { approvalItem } = useGetApprovalItemsQuery(
        {
            'target.type': 'block',
            'target.parent.type': 'area',
            'target.parent.externalId': `${areaId}`,
        },
        {
            selectFromResult: (result) => ({
                ...result,
                approvalItem: findApprovalItem(result, blockId),
            }),
        },
    );

    return approvalItem;
}
